import React from 'react';
import { Row, Col, Card, Button, Spinner } from 'react-bootstrap';

export default function CursosList({
  cursos,
  isLoading,
  onEdit,
  onDelete,
}) {
  if (isLoading) {
    return (
      <Row className='mt-5'>
        <Col className='text-center'>
          <Spinner animation='border' role='status'>
            <span className='sr-only'>Cargando...</span>
          </Spinner>
        </Col>
      </Row>
    );
  }

  if (!cursos || cursos.length === 0) {
    return (
      <Row>
        <Col className='text-center mt-5'>
          <p className='text-muted'>No hay cursos disponibles</p>
        </Col>
      </Row>
    );
  }

  return (
    <Row className='g-4'>
      {cursos.map((curso) => (
        <Col key={curso._id} md={6} lg={4} className='mb-3'>
          <Card className='h-100 shadow-sm'>
            <Card.Body>
              <Card.Title className='text-truncate' title={curso.name}>
                {curso.name}
              </Card.Title>

              <div className='mb-3'>
                {curso.description && (
                  <p className='text-muted small text-truncate'>
                    {curso.description}
                  </p>
                )}

                <div className='mt-2'>
                  {curso.durationMonths && (
                    <div className='small'>
                      <strong>Duración:</strong> {curso.durationMonths} mes
                      {curso.durationMonths !== 1 ? 'es' : ''}
                    </div>
                  )}

                  {curso.modulesCount && (
                    <div className='small'>
                      <strong>Módulos:</strong> {curso.modulesCount}
                    </div>
                  )}

                  {curso.createdAt && (
                    <div className='small'>
                      <strong>Creado:</strong>{' '}
                      {new Date(curso.createdAt).toLocaleDateString('es-AR')}
                    </div>
                  )}

                  {curso.enable !== undefined && (
                    <div className='small'>
                      <strong>Estado:</strong>{' '}
                      <span
                        className={
                          curso.enable
                            ? 'badge badge-success'
                            : 'badge badge-secondary'
                        }
                      >
                        {curso.enable ? 'Activo' : 'Inactivo'}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </Card.Body>

            <Card.Footer className='bg-transparent border-top-0'>
              <div className='d-flex gap-2'>
                <Button
                  variant='success'
                  size='sm'
                  className='flex-grow-1'
                  onClick={() => onEdit(curso)}
                >
                  <i className='mr-2 fas fa-edit' />
                  Editar
                </Button>
                <Button
                  variant='danger'
                  size='sm'
                  className='flex-grow-1'
                  onClick={() => onDelete(curso)}
                >
                  <i className='mr-2 fas fa-trash' />
                  Eliminar
                </Button>
              </div>
            </Card.Footer>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
